export const LEFT_DRAWER_FOLDER_EXPLORER_WIDTH = 'LEFT_DRAWER_FOLDER_EXPLORER_WIDTH';
export const LEFT_DRAWER_MAIN_MENU_WIDTH = 'LEFT_DRAWER_MAIN_MENU_WIDTH';
export const LEFT_DRAWER_OPEN_STATE = 'LEFT_DRAWER_OPEN_STATE';

export const RIGHT_USER_ONLINE_DRAWER_MINI_STATE = 'RIGHT_USER_ONLINE_DRAWER_MINI_STATE';
export const LEFT_DRAWER_MINI_STATE = 'LEFT_DRAWER_MINI_STATE';
